import { IonIcon, IonLabel, IonSkeletonText } from '@ionic/react';
import { eyeOutline } from 'ionicons/icons';
import Timestamp from './Timestamp';
import styles from './MicrochipItemLabel.module.css';

interface MicrochipItemLabelProps {
    rfidCode: string;
    label?: string | null;
    isLoading?: boolean;
    /** When provided, renders a "last seen" line under the code. */
    timestamp?: Date | null;
}

/**
 * Avatar tile + name/code label for microchip rows inside an IonItem.
 * Named chips get the pet mark on a primary tint; unnamed chips get a
 * neutral tag tile with the code promoted to the title line.
 */
const MicrochipItemLabel: React.FC<MicrochipItemLabelProps> = ({ rfidCode, label, isLoading, timestamp }) => {
    const name = label?.trim();

    return (
        <>
            <span
                slot="start"
                className={`${styles.avatar} ${name ? styles.avatarNamed : styles.avatarUnnamed}`}
                aria-hidden="true"
            >
                <IonIcon src={name ? '/assets/activity/activity-icon.svg' : '/assets/rfid/tag-simple.svg'} />
            </span>
            <IonLabel>
                {isLoading && <IonSkeletonText animated className={styles.nameSkeleton} />}
                {name && <h2 className={styles.name}>{name}</h2>}
                <p className={`${styles.code} ${name ? '' : styles.codeTitle}`}>{rfidCode}</p>
                {timestamp !== undefined && (
                    <p className={styles.seen}>
                        <IonIcon icon={eyeOutline} aria-hidden="true" />
                        <Timestamp timestamp={timestamp} />
                    </p>
                )}
            </IonLabel>
        </>
    );
};

export default MicrochipItemLabel;
